import React from 'react'
import styled from 'styled-components'
import {WINDOW_MODE_MOBILE_WIDTH} from 'consts'
import {useTranslation} from 'i18n'
import {GiftShopRootScreen} from 'pages'
import convertUnit from 'lib/unit'
import {GiftshopFilterRegencyList} from '../containers/GiftshopFilterRegencyList'

const StyledOuterContainer = styled.div`
  width: 100%;
  height: 100%;
  padding-top: ${convertUnit(20)};
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({theme}) => theme.white_2};
`

const StyledContainer = styled.div`
  width: calc(100% - ${convertUnit(40)});
  display: flex;
  flex-direction: column;
  max-width: ${convertUnit(561)};
  background-color: ${({theme}) => theme.white_1};
  border-radius: ${convertUnit(16)};
  max-height: ${convertUnit(710)};
  flex: 1;
  overflow: hidden;
  @media (max-width: ${WINDOW_MODE_MOBILE_WIDTH}px) {
    width: 100%;
  }
`

export default function GiftshopFilterRegencyScreen() {
  const {translate} = useTranslation()
  return (
    <GiftShopRootScreen
      headerTitle={translate('giftShop:exploreFilterRegencyTitle')}
      showBackIcon
      hideBottomNavbar={false}>
      <StyledOuterContainer>
        <StyledContainer>
          <GiftshopFilterRegencyList />
        </StyledContainer>
      </StyledOuterContainer>
    </GiftShopRootScreen>
  )
}
